import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../components/svg-icon";

const BlogDetail = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)

    let {slug} = useParams()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)
    const [blog, setBlog] = useState({})


    useEffect(() => {
        if (slug && activeLanguage?.key)
            associateServices.showBlog({
                slug,
                lang: activeLanguage?.key
            }).then(res => {
                setBlog(res?.data)
                setLoading(false)
            })
    }, [slug, activeLanguage?.key])

    return (

        loading ?
            <div className="section section--first">
                <Loading/>
            </div>
            :
            <>
                <div className="section section--first">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-xxl-8 mx-auto align-self-center">
                                <div className="col-12">
                                    <h1 className="section__title section__title--head text-center">
                                        {blog?.title}

                                        <button
                                            className="modal__close__detail"
                                            type="button"
                                            onClick={e => navigate(-1)}
                                        >
                                            <SvgIcon id={'x'}/>
                                        </button>
                                    </h1>
                                </div>

                                <div className="content">
                                    <div className="content__main content__main--big">
                                        <div className="blog__cover">
                                            <img
                                                src={blog?.image}
                                                alt=""/>
                                        </div>


                                        <div className="article">
                                            <div dangerouslySetInnerHTML={{__html: blog?.content}}/>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

    )
}


export default BlogDetail
